'use strict';

var React = require('react');

var SvgBuyButtonMajor = function SvgBuyButtonMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5.75 2.5a1.75 1.75 0 0 0-1.75 1.75v3.5c0 .966.784 1.75 1.75 1.75a.75.75 0 0 0 0-1.5.25.25 0 0 1-.25-.25v-3.5a.25.25 0 0 1 .25-.25h8.5a.25.25 0 0 1 .25.25v3.5a.25.25 0 0 1-.25.25h-.5a.75.75 0 0 0 0 1.5h.5a1.75 1.75 0 0 0 1.75-1.75v-3.5a1.75 1.75 0 0 0-1.75-1.75h-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.75 5a2.25 2.25 0 0 0-2.25 2.25v3.58l-.57-.258a1.75 1.75 0 0 0-2.429 1.216l-.07.312a2.25 2.25 0 0 0 .497 1.962l2.456 2.834a1.75 1.75 0 0 0 1.323.604h4.465a1.75 1.75 0 0 0 1.72-1.423l.67-3.523a1.75 1.75 0 0 0-1.267-2.018l-2.295-.612v-2.674a2.25 2.25 0 0 0-2.25-2.25Zm-.75 2.25a.75.75 0 0 1 1.5 0v3.25c0 .34.229.637.557.725l2.851.76a.25.25 0 0 1 .181.288l-.67 3.524a.25.25 0 0 1-.247.203h-4.465a.25.25 0 0 1-.19-.086l-2.456-2.835a.75.75 0 0 1-.165-.654l.07-.312a.25.25 0 0 1 .346-.173l1.63.735a.75.75 0 0 0 1.058-.684v-4.741Z"
  }));
};
SvgBuyButtonMajor.displayName = "BuyButtonMajor";

exports.SvgBuyButtonMajor = SvgBuyButtonMajor;
